import { actionable } from "@github/catalyst/lib/actionable";
import { target, targetable } from "@github/catalyst/lib/targetable";

export default actionable(
  targetable(
    class extends HTMLElement {
      static [target.static] = [
        "loading",
        "icon",
        "input",
        "preview",
        "fileName",
        "successIcon",
        "uploadArea",
      ];

      connectedCallback() {
        this.addEventListener("drop", this.onDrop);

        this.addEventListener("dragover", (e) => e.preventDefault());

        document.addEventListener("turbo:submit-end", this.toggleLoading);
      }

      disconnectedCallback() {
        document.removeEventListener("turbo:submit-end", this.toggleLoading);
      }

      onDrop(e) {
        e.preventDefault();

        this.input.files = e.dataTransfer.files;

        this.uploadFiles(e.dataTransfer.files);
      }

      onSelectFiles(e) {
        e.preventDefault();

        this.uploadFiles(this.input.files);
      }

      toggleLoading = (e) => {
        if (e && e.target && !e.target.contains(this)) {
          return;
        }

        this.loading.classList.toggle("hidden");
        this.icon.classList.toggle("hidden");
        this.classList.toggle("opacity-50");
      };

      showPreview(files) {
        const file = files[0];
        if (!file || !file.type.startsWith("image/")) return;
        if (!this.preview) return;

        const reader = new FileReader();

        reader.onload = (e) => {
          const img = this.preview.querySelector("img");
          if (img) {
            img.src = e.target.result;
          }

          if (this.fileName) {
            this.fileName.textContent = file.name;
          }

          // Hide the upload area (icon + text) and show the preview
          if (this.uploadArea) {
            this.uploadArea.style.display = "none";
          }
          this.preview.style.display = "";
        };

        reader.readAsDataURL(file);
      }

      uploadFiles() {
        if (this.dataset.submitOnUpload === "true") {
          this.toggleLoading();
          this.closest("form").querySelector('button[type="submit"]').click();
        } else {
          this.showPreview(this.input.files);
        }
      }
    },
  ),
);
